import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./BenefitsTicker.module.css";

/*
 * Uma copia da lista mede ~1150px: com duas o laco abria um vazio em telas
 * largas. Sao 4 copias e o passo da animacao e exatamente 1/4 da faixa, entao a
 * emenda cai sempre em cima de um item igual e a rolagem nao tem fim visivel.
 */
const COPIES = 4;

export function BenefitsTicker() {
  const { ticker, benefitsTicker } = useMaestriaContent();
  const ariaLabel = benefitsTicker?.ariaLabel ?? "Benefícios da imersão";

  return (
    <section className={styles.ticker} aria-label={ariaLabel}>
      <div className={styles.track}>
        {Array.from({ length: COPIES }, (_, copy) => (
          <div key={copy} className={styles.group} aria-hidden={copy > 0 || undefined}>
            {ticker.map((item) => (
              <span key={item} className={styles.item}>
                <svg aria-hidden="true" className={styles.diamond} viewBox="0 0 15 15">
                  <path d="M14.4958 6.70167C11.6071 5.71427 9.34872 3.44537 8.36132 0.567226C8.09872-0.189075 7.02729-0.189075 6.76469 0.567226C5.7773 3.45588 3.50839 5.71427 0.630248 6.70167C-0.126053 6.96427-0.126053 8.0357 0.630248 8.2983C3.5189 9.2857 5.7773 11.5546 6.76469 14.4327C7.02729 15.189 8.09872 15.189 8.36132 14.4327C9.34872 11.5441 11.6176 9.2857 14.4958 8.2983C15.2521 8.0357 15.2521 6.96427 14.4958 6.70167Z" />
                </svg>
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
